import * as tslib_1 from "tslib";
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { CHANNEL } from '../../../../../constants/channel.constants';
import { ExternalResponse } from '../../../../../models/channel-communicator/external-response.model';
import { ParametersService } from '../../../../parameters/parameters.service';
import { BaseChannelCommunicatorService } from '../../base-channel-communicator.service';
var MockAppImplService = /** @class */ (function (_super) {
    tslib_1.__extends(MockAppImplService, _super);
    /**
     * Constructor de la clase
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @function initService
     */
    function MockAppImplService(parametersService) {
        var _this = _super.call(this) || this;
        _this.CHANNEL_ID = CHANNEL.MOCKAPP.CODE;
        _this.initService();
        _this.url_mock_sdk = parametersService.getParameter('url_mock_sdk');
        return _this;
    }
    /**
     * Función que obtiene la información de la aplicación
     *
     * *function that obtains app information*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.getAppInfo = function () {
        return this.channelRequest('/app_properties/');
    };
    /**
     * Función que obtiene la información del usuariopara postLogin
     *
     * *function that gets user info to post login*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.getInfoClient = function () {
        return this.channelRequest('/get_user_info/');
    };
    /**
     * Función que obtiene la información del dispositivo
     *
     * *function that obtains device information*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.getDeviceInfo = function () {
        return this.channelRequest('/device_info/');
    };
    /**
     * Función que inicializa las licencias Dsb
     *
     * *function that initializes Dsb licenses*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} license
     * @returns {Promise}
     */
    MockAppImplService.prototype.initDsbLicense = function (_license) {
        return this.channelRequest('/dsb_license/');
    };
    /**
     * Función que valida la seguridad por las reglas de riesgo
     *
     * *Function that validates security by risk rules*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.isSecureByRiskRules = function () {
        return this.channelRequest('/risk_rules/');
    };
    /**
     * Función que valida la seguridad del certificado
     *
     * *Function that validates certificate security*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} secureUrl
     * @returns {Promise}
     */
    MockAppImplService.prototype.isSecureCertificate = function (_secureUrl) {
        return this.channelRequest('/secure_certificate/');
    };
    /**
     * Registra la licencia bytte para el escaneo de imágenes
     *
     * *Bytte license registration for images scanning*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} licenseRegistrationUrl
     * @returns {Promise}
     */
    MockAppImplService.prototype.registerBytteLicense = function (_licenseRegistrationUrl) {
        return this.channelRequest('/bytte_license/');
    };
    /**
     * Función que limpia los archivos residuales
     *
     * *Function cleans residual files*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.cleanResidualFiles = function () {
        return this.channelRequest('/residual_files/');
    };
    /**
     * Función que verifica y solicita los permisos
     *
     * *Function that verify and request permissions*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.verifyAndRequestPermissions = function () {
        return this.channelRequest('/request_permissions/');
    };
    /**
     * Función que envía la información a Dsb
     *
     * *Function that sends data to Dsb*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} userId
     * @returns {Promise}
     */
    MockAppImplService.prototype.sendDataToDSB = function (_userId) {
        return this.channelRequest('/send_data_dsb/');
    };
    /**
     * Función que redirige a la pantalla de login
     *
     * *function that redirect to login screen*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.redirectToLoginView = function () {
        return this.channelRequest('/login_view/');
    };
    /**
     * Función que redirige a la pantalla de lista de agencias
     *
     * *function that redirect to agency lists screen*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.redirectToAgencyListView = function () {
        return this.channelRequest('/agency_list_view/');
    };
    /**
     * Función que redirige a la pantalla para abrir el archivo en pdf
     *
     * *function that redirect to open pdf file*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.openPdf = function (_url) {
        return this.channelRequest('/open_pdf/');
    };
    /**
     * Función que redirige a la pantalla de configuración del dispositivo
     *
     * *Function that redirects to settings device screen*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.goToSettingsDevice = function () {
        return this.channelRequest('/settings_device/');
    };
    /**
     * Función que retorna el servicio para escanear la parte de atrás del documento
     *
     * *Function that returns back document scan service*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} licenseAndroid
     * @param {string} licenseIos
     * @param {string} password
     * @param {number} timeout
     * @returns {Promise}
     */
    MockAppImplService.prototype.backDocumentScan = function (_licenseAndroid, _licenseIos, _password, _timeout) {
        return this.channelRequest('/back_document_scan/');
    };
    /**
     * Función que retorna el servicio para escanear la parte de adelante del documento
     *
     * *Function that returns front document scan service*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} licenseAndroid
     * @param {string} licenseIos
     * @param {string} password
     * @param {number} timeout
     * @returns {Promise}
     */
    MockAppImplService.prototype.frontDocumentScan = function (_licenseAndroid, _licenseIos, _password, _timeout) {
        return this.channelRequest('/front_document_scan/');
    };
    /**
     * Función que retorna el servicio para escanear las huellas digitales del usuario
     *
     * *Function that returns user's fringer print scan service*
     *
     * @type {function}
     * @type {Promise<any>}
     * @param {string} licenseAndroid
     * @param {string} licenseIos
     * @param {string} password
     * @param {number} timeout
     * @returns {Promise}
     */
    MockAppImplService.prototype.fingerPrintsScan = function (_fingerPrintSigned, _password, _timeout) {
        return this.channelRequest('/finger_print_scan/');
    };
    /**
     * Función que obtiene token en portal
     *
     * *function that gets token in portal*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.getObjectDataPortal = function () {
        return this.channelRequest('/get_token_portal/');
    };
    /**
     * Función que trae la data de la vitrina desde portal
     *
     * *Function get data offer from portal*
     *
     * @type {function}
     * @type {Promise<any>}
     * @returns {Promise}
     */
    MockAppImplService.prototype.getFirmlyApprovedPortal = function () {
        return this.channelRequest('/get_firmly_approved_portal/');
    };
    /**
     * Creación de la promesa para la comunicación con portalpn
     *
     * *Promise creation for portalpn communication*
     *
     * @param {string} op
     */
    MockAppImplService.prototype.createPromise = function (op) {
        return new Promise(function (resolve, _reject) {
            var data;
            var callback = function (event) {
                try {
                    data = JSON.parse(event.data);
                }
                catch (error) {
                    return;
                }
                if (data.origin !== CHANNEL.SUPERAPP.NAME || data.op !== op) {
                    return;
                }
                resolve(data);
                window.removeEventListener('message', callback);
                document.removeEventListener('message', callback);
            };
            window.addEventListener('message', callback);
            document.addEventListener('message', callback);
        });
    };
    /**
     * Llamada a una función Nativa dependiendo del canal
     *
     * *Calls native function depending on the channel*
     *
     * @param {ExternalRequest} request
     */
    MockAppImplService.prototype.postMessageToChannel = function (request) {
        var _this = this;
        var getExternalContext = function () {
            return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var maxTime, gradient, i;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            maxTime = 5000;
                            gradient = 100;
                            i = gradient;
                            _a.label = 1;
                        case 1:
                            if (!(i < maxTime)) return [3 /*break*/, 4];
                            if (window['ReactNativeWebView']) {
                                resolve(window['ReactNativeWebView']);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, new Promise(function (innerResolve) {
                                    setTimeout(innerResolve, gradient);
                                })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += gradient;
                            return [3 /*break*/, 1];
                        case 4:
                            reject('Fatal. External context not found.');
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        window.parent.postMessage(JSON.stringify(request), '*');
        getExternalContext().then(function (context) {
            context.postMessage(JSON.stringify(request));
        }, function (err) {
            console.error(err + ' Application unavailable.');
        });
    };
    MockAppImplService.prototype.channelRequest = function (functionName) {
        var case_number = localStorage.getItem('case_number') !== null ? localStorage.getItem('case_number') : '0';
        return this.request(this.url_mock_sdk + functionName + case_number + '.json');
    };
    MockAppImplService.prototype.request = function (url) {
        var httpClient = new HttpClient(new HttpXhrBackend({ build: function () { return new XMLHttpRequest(); } }));
        return new Promise(function (resolve, reject) {
            httpClient.get(url, { observe: 'response' }).toPromise().then(function (response) {
                resolve(Object.assign(new ExternalResponse(), response.body));
            }, function (error) {
                reject(error);
            });
        });
    };
    return MockAppImplService;
}(BaseChannelCommunicatorService));
export { MockAppImplService };
